<template>
  <div class="content">
    <!-- <video class="background" style="
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      margin-bottom: -3px;" src="../../assets/bg-0622.mp4" autoplay loop muted></video> -->
    <div class="groups-body">
      <div
        class="group-card"
        v-for="group in visibleGroups"
        :key="group.name"
      >
        <div class="group-header">
          <div class="group-name">{{ group.name }}</div>
          <div class="group-count">{{ group.members.length }}人</div>
        </div>
        <div class="group-members">
          <div class="member-item" v-for="member in group.members" :key="member.id">
            <div class="member-avatar">
              <img :src="member.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
            </div>
            <div class="member-name">{{ member.nickname }}</div>
          </div>
          <div v-if="group.members.length === 0" class="empty-tip">暂无成员</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../axios-instance'
import userList from './data-0622.js'

export default {
  name: 'pageTpGroups2',
  data () {
    return {
      groups: {},
      groupNames: ['1组', '2组'],
      personList: userList || [],
      touxiang: require('../../assets/touxiang.png')
    }
  },
  computed: {
    visibleGroups () {
      return this.groupNames.map(name => {
        const memberIds = (this.groups || {})[name] || []
        const members = memberIds
          .map(id => this.personList.find(p => p.id === id))
          .filter(Boolean)
        return { name, members }
      })
    }
  },
  mounted () {
    this.getGroupsInfo()
    setInterval(() => {
      this.getGroupsInfo()
    }, 3000)
  },
  methods: {
    getGroupsInfo () {
      axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/kv/get/groups`,
        method: 'get'
      })
        .then((res) => {
          if (res && res.data && res.data.data) {
            try {
              const parsed = JSON.parse(res.data.data)
              if (parsed && typeof parsed === 'object') {
                this.groups = parsed
              }
            } catch (e) {
              console.error('分组数据解析失败：', e)
            }
          }
        })
        .catch((e) => {
          console.error('获取分组数据失败：', e)
        })
    }
  }
}
</script>

<style scoped>
.content {
  position: relative;
  width: 3000px;
  height: 1200px;
  font-size: 22px;
  background: green;
  overflow: hidden;
}

.groups-body {
  position: relative;
  width: 40%;
  height: 100%;
  left: 30%;
  top: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
  padding: 1.5% 8px;
  box-sizing: border-box;
  z-index: 10;
  overflow: hidden;
}

.group-card {
  display: flex;
  flex-direction: column;
  border: 2px solid #8a7352;
  border-radius: 14px;
  background: linear-gradient(135deg, rgb(61 23 102) 0%, rgb(90 24 154) 50%, rgb(123 44 191) 100%);
  padding: 14px;
  box-shadow:
    0 0 16px rgba(123, 44, 191, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.45),
    0 3px 6px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  min-height: 0;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(201, 162, 39, 0.4);
}

.group-name {
  font-size: 30px;
  font-weight: bold;
  color: #e6d49a;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.group-count {
  font-size: 22px;
  color: #f0f0f0;
}

.group-members {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px 12px;
  flex: 1;
  align-content: center;
  justify-items: center;
  overflow: hidden;
  padding: 10px;
}

.member-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
}

.member-avatar {
  width: 175px;
  height: 175px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #9a825f;
  box-shadow: 0 0 8px rgba(123, 44, 191, 0.3);
  margin-bottom: 6px;
}

.touxiang {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.member-name {
  font-size: 24px;
  line-height: 1.2;
  color: #fff;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}

.empty-tip {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: rgba(240, 240, 240, 0.7);
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page260622/page-tp-groups2.vue